import { Box, Center, Flex, LoaderV2, Stack } from '@zorro/web/design-system';
import { ReactNode } from 'react';

import { AppLayoutConstants } from '../AppLayout';

type FullPageLoaderProps = {
  children?: ReactNode;
};

export const FullPageLoader = ({ children }: FullPageLoaderProps) => {
  return (
    <Center
      style={{
        height: `calc(100vh - var(--app-layout-header-height, ${AppLayoutConstants.HEADER_HEIGHT}) - 2 * var(--mantine-spacing-sm))`,
      }}
    >
      <Box style={{ transform: 'translate(0, -50%)' }}>
        <Flex justify="center" align="center" h="100%">
          <Stack align="center">
            <LoaderV2 />
            {children}
          </Stack>
        </Flex>
      </Box>
    </Center>
  );
};
